<template>
    <div class="lw-cols align-items-stretch one-row one-row-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp j-c-c">

        <div v-if="coursesVisibility" :class="panelStyleClass" class="col lw-padding-normal learnworlds-align-center span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item flexible">
           <h2 class="learnworlds-subheading learnworlds-subheading-large learnworlds-element">
                {{coursesLength}}
            </h2>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large lw-text-color-fadeout50">
                {{ $t('bundles.courses') }}
            </div>
        </div>

        <div v-if="initialPriceVisibility" :class="panelStyleClass" class="col lw-padding-normal learnworlds-align-center span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item flexible ">
            <h2 class="learnworlds-subheading learnworlds-subheading-large learnworlds-element">
                {{bundle.currency || '$'}}{{bundle.price}}
            </h2>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large lw-text-color-fadeout50">
                {{ $t('bundles.price') }}
            </div>
        </div>

        <div v-if="finalPriceVisibility" :class="panelStyleClass" class="col lw-padding-normal learnworlds-align-center span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item flexible ">
            <h2 class="learnworlds-subheading learnworlds-subheading-large learnworlds-element">
                {{bundle.currency || '$'}}{{bundle.discount_price}}
            </h2>>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large lw-text-color-fadeout50">
                {{ $t('bundles.price_final') }}
            </div>
        </div>

        <div v-if="discountPercentageVisibility" :class="panelStyleClass" class="col lw-padding-normal learnworlds-align-center span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item flexible">
            <h2 class="learnworlds-subheading learnworlds-subheading-large learnworlds-element">
                {{bundle.discount_percentage}}%
            </h2>>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large lw-text-color-fadeout50">
                {{ $t('bundles.discount') }}
            </div>
        </div>

        <div v-if="savingsVisibility" :class="panelStyleClass" class="col lw-padding-normal learnworlds-align-center span_4_of_12 span_4_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp flex-item flexible ">
            <h2 class="learnworlds-subheading learnworlds-subheading-large learnworlds-element">
                {{bundle.currency || '$'}}{{bundle.save}}
            </h2>>
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-large lw-text-color-fadeout50">
                {{ $t('bundles.save') }}
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";
    export default {
        name: "BundleDataLayout3",
        mixins: [
            ComponentTemplatesMixin,
        ],
        props: {
            bundle : {
                type: Object
            },
            coursesVisibility: {
                type: Boolean
            },
            initialPriceVisibility: {
                type: Boolean
            },
            finalPriceVisibility: {
                type: Boolean
            },
            discountPercentageVisibility: {
                type: Boolean
            },
            savingsVisibility: {
                type: Boolean
            },
            panelStyleClass: {
                type: String
            },
        },
        computed: {
            coursesLength () {
                return this.bundle && this.bundle.courses ? this.bundle.courses.length : 0;
            }
        },
        methods: {
            $t (val) {
                return window.LWTranslate.get(val);
            },
        },
    }
</script>
